import React, { useState, useEffect, useCallback } from 'react'; 
import { auth, db } from '../AppointmentComp/firebase';
import { collection, getDocs, deleteDoc, doc, updateDoc, addDoc, query, orderBy, onSnapshot, limit, where, serverTimestamp } from 'firebase/firestore';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import './adminpanel.css';
import emailjs from 'emailjs-com'; 

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faSave, faTimes, faSearch, faFilter } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { Timestamp } from "firebase/firestore";





function AdminPanel() {


  const [activeTab, setActiveTab] = useState('createPrescription'); // Default tab
  const [users, setUsers] = useState([]);

  //specs repair
  const [jobNo, setJobNo] = useState("");
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [issue, setIssue] = useState("");
  const [date, setDate] = useState("");
  const [status, setStatus] = useState("");
  const [searchJobNo, setSearchJobNo] = useState("");
  const [searchName, setSearchName] = useState("");


  const [isSubmitting, setIsSubmitting] = useState(false);

  const [repairs, setRepairs] = useState([]);
  const [loadingRepairs, setLoadingRepairs] = useState(false);

  // 🔹 FILTER STATES (RENAMED)
  const [repairStatusFilter, setRepairStatusFilter] = useState("");
  const [repairYearFilter, setRepairYearFilter] = useState("");
  const [repairMonthFilter, setRepairMonthFilter] = useState("");
  const [repairDateFilter, setRepairDateFilter] = useState("");

  // Filters
  const [filterStatus, setFilterStatus] = useState("");
  const [filterDate, setFilterDate] = useState("");





  // Fetch all users
  const fetchUsers = useCallback(async () => {
    try {
      const userRef = collection(db, 'users');
      const snapshot = await getDocs(userRef);
      const usersData = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error.message);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 'viewUsers' || activeTab === 'manageUsers') {
      fetchUsers();
    }
  }, [activeTab, fetchUsers]);

  // Remove user with confirmation
  const handleRemoveUser = async (userId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this member?");
    if (!confirmDelete) return; 

    try {
      await deleteDoc(doc(db, 'users', userId));  
      setUsers(prevUsers => prevUsers.filter(user => user.id !== userId)); 
    } catch (error) {
      console.error("Error removing user:", error.message);
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };



  const handleLogout = async () => {
    try {
      await auth.signOut();
      window.location.href = '/';  
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  useEffect(() => {
    document.body.classList.add('admin-panel-active');
    return () => {
      document.body.classList.remove('admin-panel-active');
    };
  }, []);





//fetch all the messages from the contacts
 const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        // Create a query that orders by createdAt timestamp (newest first)
        const q = query(
          collection(db, "contactus"), 
          orderBy("createdAt", "desc")
        );
        
        const querySnapshot = await getDocs(q);
        const contactMessages = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          // Format the timestamp for display
          formattedDate: doc.data().createdAt?.toDate().toLocaleString() || 'N/A'
        }));
        
        setMessages(contactMessages);
        setError('');
      } catch (err) {
        console.error("Error fetching messages:", err);
        setError('Failed to load messages. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);





// spectacles repair
const handleSpecsRepairSubmit = async (e) => {
  e.preventDefault();

  // ⛔ Block multiple clicks
  if (isSubmitting) return;

  setIsSubmitting(true);

  try {
    await addDoc(collection(db, "repairspecs"), {
      jobNo,
      name,
      contact,
      issue,
      date,
      status,
      createdAt: serverTimestamp(),
    });

    alert("Specs repair job saved successfully!");

    // Clear form
    setJobNo("");
    setName("");
    setContact("");
    setIssue("");
    setDate("");
    setStatus("");

  } catch (error) {
    console.error("Error saving repair job:", error);
    alert("Failed to save repair job");
  } finally {
    setIsSubmitting(false); // ✅ Re-enable button
  }
};








//view all repair specs

const fetchRepairs = async () => {
  setLoadingRepairs(true);
  try {
    const q = query(
      collection(db, "repairspecs"),
      orderBy("createdAt", "desc")
    );

    const snapshot = await getDocs(q);

    const list = snapshot.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));

    setRepairs(list);
  } catch (error) {
    console.error("Error fetching repairs:", error);
  }
  setLoadingRepairs(false);
};

useEffect(() => {
  fetchRepairs();
}, []);

// ===============================
// UPDATE STATUS
// ===============================

const updateRepairStatus = async (id, newStatus) => {
  const updateData = { status: newStatus };

  if (newStatus === "pending" || newStatus === "in progress") {
    updateData.completedDate = "";
    updateData.deliveredDate = "";
  }

  try {
    await updateDoc(doc(db, "repairspecs", id), updateData);

    setRepairs((prev) =>
      prev.map((r) =>
        r.id === id ? { ...r, ...updateData } : r
      )
    );
  } catch (error) {
    console.error("Failed to update status:", error);
  }
};

// ===============================
// UPDATE COMPLETED / DELIVERED DATE
// ===============================

const updateRepairDate = async (id, field, value) => {
  try {
    await updateDoc(doc(db, "repairspecs", id), {
      [field]: value,
    });

    setRepairs((prev) =>
      prev.map((r) =>
        r.id === id ? { ...r, [field]: value } : r
      )
    );
  } catch (error) {
    console.error("Date update failed:", error);
  }
};

// ===============================
// FILTER + SEARCH LOGIC
// ===============================

const filteredRepairs = repairs.filter((r) => {
  if (!r.date) return false;

  const repairDateObj = new Date(r.date);

  return (
    (!repairStatusFilter || r.status === repairStatusFilter) &&
    (!repairYearFilter ||
      repairDateObj.getFullYear().toString() === repairYearFilter) &&
    (!repairMonthFilter ||
      (repairDateObj.getMonth() + 1)
        .toString()
        .padStart(2, "0") === repairMonthFilter) &&
    (!repairDateFilter || r.date === repairDateFilter) &&
    (!searchJobNo ||
      r.jobNo.toLowerCase().includes(searchJobNo.toLowerCase())) &&
    (!searchName ||
      r.name.toLowerCase().includes(searchName.toLowerCase()))
  );
});





















//loyalty cutomer
const [formData, setFormData] = useState({
  name: '',
  loyaltyNumber: '',
  address: '',
  phone: '',
  email: '',
  password: ''
});

const [submitting, setSubmitting] = useState(false);
const [success, setSuccess] = useState(false);

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitting(true);
  setError('');

  try {
    // 1. Save data to Firestore
    await addDoc(collection(db, 'loyaltybase'), {
      ...formData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      status: 'active'
    });

    // 2. Send email to the customer
    await emailjs.send('service_tqyzrz1', 'template_t4cwy4h', {
      name: formData.name,
      loyaltyNumber: formData.loyaltyNumber,
      email: formData.email
    }, 'V7GeEtMQ7Wi0eUrRM');

    setSuccess(true);

    // 3. Reset form
    setFormData({
      name: '',
      loyaltyNumber: '',
      address: '',
      phone: '',
      email: '',
      password: ''
    });

    // Hide success message
    setTimeout(() => setSuccess(false), 5000);
  } catch (err) {
    console.error("Error saving or sending email:", err);
    setError('Failed to save data or send email. Please try again.');
  } finally {
    setSubmitting(false);
  }
};







// Fetch all loyalty customers
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [yearFilter, setYearFilter] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({
    name: '',
    email: '',
    phone: '',
    address: ''
  });

  // Fetch all loyalty customers
  useEffect(() => {
    const fetchLoyaltyCustomers = async () => {
      try {
        const q = query(collection(db, "loyaltybase"));
        const querySnapshot = await getDocs(q);
        
        let loyaltyCustomers = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          const joinedDate = data.createdAt?.toDate();
          return {
            id: doc.id,
            ...data,
            joinedDate,
            year: joinedDate ? joinedDate.getFullYear() : 'N/A'
          };
        });

        // Sort by loyalty number numerically
        loyaltyCustomers = loyaltyCustomers.sort((a, b) => {
          const numA = parseInt(a.loyaltyNumber.replace(/\D/g, ''), 10);
          const numB = parseInt(b.loyaltyNumber.replace(/\D/g, ''), 10);
          return numA - numB;
        });
        
        setCustomers(loyaltyCustomers);
        setFilteredCustomers(loyaltyCustomers);
        setError('');
      } catch (err) {
        console.error("Error fetching loyalty customers:", err);
        setError('Failed to load customers. Please try again.');
        toast.error('Failed to load customers');
      } finally {
        setLoading(false);
      }
    };

    fetchLoyaltyCustomers();
  }, []);

  // Filter customers based on search term and year filter
  useEffect(() => {
    let result = [...customers];
    
    // Apply search filter
    if (searchTerm.trim() !== '') {
      const term = searchTerm.toLowerCase();
      result = result.filter(customer => 
        customer.name.toLowerCase().includes(term) ||
        customer.phone.includes(searchTerm) ||
        customer.loyaltyNumber.includes(searchTerm)
      );
    }
    
    // Apply year filter
    if (yearFilter) {
      result = result.filter(customer => 
        customer.year === parseInt(yearFilter)
      );
    }
    
    setFilteredCustomers(result);
  }, [searchTerm, yearFilter, customers]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleEdit = (customer) => {
    setEditingId(customer.id);
    setEditForm({
      name: customer.name,
      email: customer.email,
      phone: customer.phone,
      address: customer.address
    });
  };

  const handleCancelEdit = () => {
    setEditingId(null);
  };

  const handleSaveEdit = async () => {
    try {
      await updateDoc(doc(db, "loyaltybase", editingId), editForm);
      
      setCustomers(customers.map(customer => 
        customer.id === editingId ? { ...customer, ...editForm } : customer
      ));
      
      toast.success('Customer updated successfully');
      setEditingId(null);
    } catch (err) {
      console.error("Error updating customer:", err);
      toast.error('Failed to update customer');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this customer?')) return;
    
    try {
      await deleteDoc(doc(db, "loyaltybase", id));
      setCustomers(customers.filter(customer => customer.id !== id));
      toast.success('Customer deleted successfully');
    } catch (err) {
      console.error("Error deleting customer:", err);
      toast.error('Failed to delete customer');
    }
  };

  // Generate year options from data
  const getYearOptions = () => {
    const years = new Set();
    customers.forEach(customer => {
      if (customer.year && customer.year !== 'N/A') {
        years.add(customer.year);
      }
    });
    return Array.from(years).sort((a, b) => b - a); // Sort descending
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };







//add patients
  const [formPatientData, setFormPatientData] = useState({
    name: "",
    gender: "",
    age: "",
    dob: "",
    contact: "",
    address: "",
    prescribedDate: "",
    prescriptionOld: "",
    prescriptionNew: "",
    specialDisease: "",
    followUpDate: "",
    lensType: "",
  });

  const [successMsg, setSuccessMsg] = useState("");

  const handlePatientChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePatientSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(db, "patients"), {
        ...formData,
        createdAt: Timestamp.now(),
      });
      setSuccessMsg("Patient added successfully!");
      setFormData({
        name: "",
        gender: "",
        age: "",
        dob: "",
        contact: "",
        address: "",
        prescribedDate: "",
        prescriptionOld: "",
        prescriptionNew: "",
        specialDisease: "",
        followUpDate: "",
        lensType: "",
      });
    } catch (error) {
      console.error("Error adding patient:", error);
    }
    setLoading(false);
  };



// fetch all patients
const [patients, setPatients] = React.useState([]);
const [editPatientId, setEditPatientId] = React.useState(null);
const [editFormData, setEditFormData] = React.useState({});
const [alertMessage, setAlertMessage] = React.useState(null); // ✅ alert state

// fetch patients from Firestore
React.useEffect(() => {
  const fetchPatients = async () => {
    const snapshot = await getDocs(collection(db, "patients"));
    setPatients(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
  };
  fetchPatients();
}, []);

// delete handler
const handlePatientDelete = async (id) => {
  if (window.confirm("Are you sure you want to delete this patient?")) {
    await deleteDoc(doc(db, "patients", id));
    setPatients(patients.filter((p) => p.id !== id));
    setAlertMessage({ type: "delete", text: "❌ Patient deleted successfully!" });
    setTimeout(() => setAlertMessage(null), 3000);
  }
};

// edit click
const handlePatientEditClick = (patient) => {
  setEditPatientId(patient.id);
  setEditFormData({ ...patient });
};

// change fields while editing
const handlePatientEditChange = (e) => {
  setEditFormData({ ...editFormData, [e.target.name]: e.target.value });
};

// save edit
const handlePatientSaveEdit = async (e, id) => {
  e.preventDefault();
  await updateDoc(doc(db, "patients", id), editFormData);
  setPatients(
    patients.map((p) => (p.id === id ? { id, ...editFormData } : p))
  );
  setEditPatientId(null);

  // ✅ success alert
  setAlertMessage({ type: "success", text: "✅ Patient updated successfully!" });
  setTimeout(() => setAlertMessage(null), 3000);
};

// cancel edit
const handlePatientCancelEdit = () => {
  setEditPatientId(null);
};






// states for search and filter
const [filterYear, setFilterYear] = React.useState("");
const [filterMonth, setFilterMonth] = React.useState("");

// 🔎 filtered patients based on search + year + month
const filteredPatients = patients.filter((patient) => {
  const nameMatch = patient.name?.toLowerCase().includes(searchTerm.toLowerCase());
  const phoneMatch = patient.contact?.includes(searchTerm);

  // check year & month filter against prescribedDate
  let dateMatch = true;
  if (filterYear || filterMonth) {
    if (patient.prescribedDate) {
      const dateObj = new Date(patient.prescribedDate);
      const year = dateObj.getFullYear().toString();
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");

      if (filterYear && year !== filterYear) dateMatch = false;
      if (filterMonth && month !== filterMonth) dateMatch = false;
    } else {
      dateMatch = false;
    }
  }

  return (nameMatch || phoneMatch) && dateMatch;
});








///////////////////// view feedbacks  //////////////////////////////////////////////

const [followupStatus, setFollowupStatus] = useState({});
const [statusInput, setStatusInput] = useState({});

//fetch all the feedbacks

 const [feedbacks, setFeedbacks] = useState([]);

  useEffect(() => {
    if (activeTab !== "feedbacks") return;

    const q = query(collection(db, "feedbacks"), orderBy("timestamp", "desc"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const feedbackData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setFeedbacks(feedbackData);
    });

    return () => unsubscribe();
  }, [activeTab]);






  // create prescription 
const [patient, setPatient] = useState({
    date: "",
    appointmentNo: "",
    name: "",
    age: "",
    dob: "",
    address: "",
    contact: "",
    remark: "",
  });

  const [rx, setRx] = useState({
    hbRx: {
      right: { sph: "", cyl: "", axis: "", add: "" },
      left: { sph: "", cyl: "", axis: "", add: "" },
    },
    rx: {
      right: { sph: "", cyl: "", axis: "", add: "" },
      left: { sph: "", cyl: "", axis: "", add: "" },
    },
  });

  const handlePrescriptionChange = (field, value) => {
    setPatient({ ...patient, [field]: value });
  };

  const handleRxChange = (section, eye, field, value) => {
    setRx((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [eye]: {
          ...prev[section][eye],
          [field]: value,
        },
      },
    }));
  };




 
  /* ================= PDF ================= */
const generatePDF = () => {
  const doc = new jsPDF();

  // Load fonts - using Roboto for professional look
  doc.setFont("helvetica", "normal");

  // Add logo if available
  try {
    const logo = new Image();
    logo.src = '/optical-logo.png';
    doc.addImage(logo, 'PNG', 14, 10, 40, 40);
  } catch (e) {
    console.log("Logo not found, continuing without it");
  }

  // Company Header with better typography
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  doc.text("EYE CARE CLINIC & OPTICAL", 65, 20);
  
  doc.setFontSize(11);
  doc.setFont("helvetica", "italic");
  doc.setTextColor(0, 102, 204); // Blue color for tagline
  doc.text("Our Mission, Your Vision", 65, 27);
  
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0, 0, 0); // Reset to black
  doc.text("932, Maradana Road, Colombo 08", 65, 34);
  doc.text("Phone: 011 268 2277 | 076 136 0944", 65, 39);
  doc.text("Email: eyecareoptical2024@gmail.com", 65, 44);

  // Decorative line
  doc.setDrawColor(0, 102, 204); // Blue line
  doc.setLineWidth(0.5);
  doc.line(14, 50, 196, 50);

  // Patient Information Section
doc.setFontSize(14);
doc.setFont("helvetica", "bold");
doc.setTextColor(51, 51, 51);
doc.text("PATIENT INFORMATION", 14, 60);

// Define column positions
const leftLabelX = 14;
const leftDataX = 50; // Fixed position for all data after labels
const rightLabelX = 120;
const rightDataX = 155; // Fixed position for all data after labels in right column

doc.setFontSize(10);

// Left column - Labels
doc.setFont("helvetica", "bold");
doc.text("Date:", leftLabelX, 70);
doc.text("Name:", leftLabelX, 76);
doc.text("Date of Birth:", leftLabelX, 82);
doc.text("Address:", leftLabelX, 88);

// Left column - Data (all aligned at same position)
doc.setFont("helvetica", "normal");
doc.text(patient.date, leftDataX, 70);
doc.text(patient.name, leftDataX, 76);
doc.text(patient.dob, leftDataX, 82);

// Address with word wrap - also aligned at same position
const addressLines = doc.splitTextToSize(patient.address, 80);
doc.text(addressLines, leftDataX, 88);

// Right column - Labels
doc.setFont("helvetica", "bold");
doc.text("Appointment No:", rightLabelX, 70);
doc.text("Age:", rightLabelX, 76);
doc.text("Contact No:", rightLabelX, 82);

// Right column - Data (all aligned at same position)
doc.setFont("helvetica", "normal");
doc.text(patient.appointmentNo, rightDataX, 70);
doc.text(patient.age, rightDataX, 76);
doc.text(patient.contact, rightDataX, 82);






  // Helper function for prescription tables
  const renderRx = (title, data, startY) => {
    // Section title
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(63, 63, 149); // Blue title
    doc.text(title, 14, startY);

    // Table header
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(255, 255, 255); // White text
    doc.setFillColor(63, 63, 149); // Blue background
    doc.rect(14, startY + 5, 180, 8, 'F');
    
    doc.text("Eye", 20, startY + 10);
    doc.text("SPH", 55, startY + 10);
    doc.text("CYL", 90, startY + 10);
    doc.text("Axis", 125, startY + 10);
    doc.text("Add", 160, startY + 10);

    // Table rows
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    doc.setFillColor(245, 245, 245); // Light gray for alternate rows

    // Right eye row
    doc.rect(14, startY + 13, 180, 8, 'F');
    doc.text("Right (OD)", 20, startY + 18);
    doc.text(data.right.sph || "-", 55, startY + 18);
    doc.text(data.right.cyl || "-", 90, startY + 18);
    doc.text(data.right.axis || "-", 125, startY + 18);
    doc.text(data.right.add || "-", 160, startY + 18);

    // Left eye row
    doc.setFillColor(255, 255, 255); // White for second row
    doc.rect(14, startY + 21, 180, 8, 'F');
    doc.text("Left (OS)", 20, startY + 26);
    doc.text(data.left.sph || "-", 55, startY + 26);
    doc.text(data.left.cyl || "-", 90, startY + 26);
    doc.text(data.left.axis || "-", 125, startY + 26);
    doc.text(data.left.add || "-", 160, startY + 26);

    return startY + 35;
  };

  // Render both prescriptions
  let currentY = 110;
  currentY = renderRx("Hb RX", rx.hbRx, currentY);
  renderRx("RX", rx.rx, currentY);


  doc.setFontSize(10);
  doc.setFont("helvetica", "italic");
  doc.text(`Remarks: ${patient.remark || 'N/A'}`, 14, currentY + 50);

  // Footer with timestamp
  doc.setFontSize(8);
  doc.setFont("helvetica", "italic");
  doc.setTextColor(128, 128, 128);
  const timestamp = new Date().toLocaleString();
  doc.text(`Generated: ${timestamp}`, 14, 280);
  doc.text("Eye Care Clinic & Optical", 105, 280, null, null, "center");

  // Save PDF
  doc.save(`Prescription_${patient.name.replace(/\s+/g, '_')}_${patient.appointmentNo}.pdf`);
};




const savePrescription = async () => {
  try {
    // Save to database
    await addDoc(collection(db, "prescriptions"), {
      patient,
      ...rx,
      createdAt: Timestamp.now(),
    });

    // Generate and download PDF
    generatePDF();
    
    // Show success message
    alert("Prescription saved successfully! PDF download has started.");
    
  } catch (error) {
    console.error("Error saving prescription:", error);
    alert("Error saving prescription. Please try again.");
  }
};


////////////////////////////////////////// view prescription ///////////////////////////////////////////////////////

  const [prescriptions, setPrescriptions] = useState([]);

  useEffect(() => {
    fetchPrescriptions();
  }, []);

  const fetchPrescriptions = async () => {
    const q = query(
      collection(db, "prescriptions"),
      orderBy("createdAt", "desc") 
    );

    const snapshot = await getDocs(q);
    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setPrescriptions(data);
  };

  const handlePrescriptionDelete = async (id) => {
    if (!window.confirm("Delete this prescription?")) return;

    await deleteDoc(doc(db, "prescriptions", id));
    fetchPrescriptions();
  };


const generatePrescriptionPDF = (patient, rx) => {
 const doc = new jsPDF();

  // Load fonts - using Roboto for professional look
  doc.setFont("helvetica", "normal");

  // Add logo if available
  try {
    const logo = new Image();
    logo.src = '/optical-logo.png';
    doc.addImage(logo, 'PNG', 14, 10, 40, 40);
  } catch (e) {
    console.log("Logo not found, continuing without it");
  }

  // Company Header with better typography
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  doc.text("EYE CARE CLINIC & OPTICAL", 65, 20);
  
  doc.setFontSize(11);
  doc.setFont("helvetica", "italic");
  doc.setTextColor(0, 102, 204); // Blue color for tagline
  doc.text("Our Mission, Your Vision", 65, 27);
  
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(0, 0, 0); // Reset to black
  doc.text("932, Maradana Road, Colombo 08", 65, 34);
  doc.text("Phone: 011 268 2277 | 076 136 0944", 65, 39);
  doc.text("Email: eyecareoptical2024@gmail.com", 65, 44);

  // Decorative line
  doc.setDrawColor(0, 102, 204); // Blue line
  doc.setLineWidth(0.5);
  doc.line(14, 50, 196, 50);

  // Patient Information Section
doc.setFontSize(14);
doc.setFont("helvetica", "bold");
doc.setTextColor(51, 51, 51);
doc.text("PATIENT INFORMATION", 14, 60);

// Define column positions
const leftLabelX = 14;
const leftDataX = 50; // Fixed position for all data after labels
const rightLabelX = 120;
const rightDataX = 155; // Fixed position for all data after labels in right column

doc.setFontSize(10);

// Left column - Labels
doc.setFont("helvetica", "bold");
doc.text("Date:", leftLabelX, 70);
doc.text("Name:", leftLabelX, 76);
doc.text("Date of Birth:", leftLabelX, 82);
doc.text("Address:", leftLabelX, 88);

// Left column - Data (all aligned at same position)
doc.setFont("helvetica", "normal");
doc.text(patient.date, leftDataX, 70);
doc.text(patient.name, leftDataX, 76);
doc.text(patient.dob, leftDataX, 82);

// Address with word wrap - also aligned at same position
const addressLines = doc.splitTextToSize(patient.address, 80);
doc.text(addressLines, leftDataX, 88);

// Right column - Labels
doc.setFont("helvetica", "bold");
doc.text("Appointment No:", rightLabelX, 70);
doc.text("Age:", rightLabelX, 76);
doc.text("Contact No:", rightLabelX, 82);

// Right column - Data (all aligned at same position)
doc.setFont("helvetica", "normal");
doc.text(patient.appointmentNo, rightDataX, 70);
doc.text(patient.age, rightDataX, 76);
doc.text(patient.contact, rightDataX, 82);






  // Helper function for prescription tables
  const renderRx = (title, data, startY) => {
    // Section title
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(63, 63, 149); // Blue title
    doc.text(title, 14, startY);

    // Table header
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(255, 255, 255); // White text
    doc.setFillColor(63, 63, 149); // Blue background
    doc.rect(14, startY + 5, 180, 8, 'F');
    
    doc.text("Eye", 20, startY + 10);
    doc.text("SPH", 55, startY + 10);
    doc.text("CYL", 90, startY + 10);
    doc.text("Axis", 125, startY + 10);
    doc.text("Add", 160, startY + 10);

    // Table rows
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    doc.setFillColor(245, 245, 245); // Light gray for alternate rows

    // Right eye row
    doc.rect(14, startY + 13, 180, 8, 'F');
    doc.text("Right (OD)", 20, startY + 18);
    doc.text(data.right.sph || "-", 55, startY + 18);
    doc.text(data.right.cyl || "-", 90, startY + 18);
    doc.text(data.right.axis || "-", 125, startY + 18);
    doc.text(data.right.add || "-", 160, startY + 18);

    // Left eye row
    doc.setFillColor(255, 255, 255); // White for second row
    doc.rect(14, startY + 21, 180, 8, 'F');
    doc.text("Left (OS)", 20, startY + 26);
    doc.text(data.left.sph || "-", 55, startY + 26);
    doc.text(data.left.cyl || "-", 90, startY + 26);
    doc.text(data.left.axis || "-", 125, startY + 26);
    doc.text(data.left.add || "-", 160, startY + 26);

    return startY + 35;
  };

  // Render both prescriptions
  let currentY = 110;
  currentY = renderRx("Hb RX", rx.hbRx, currentY);
  renderRx("RX", rx.rx, currentY);


  doc.setFontSize(10);
  doc.setFont("helvetica", "italic");
  doc.text(`Remarks: ${patient.remark || 'N/A'}`, 14, currentY + 50);

  // Footer with timestamp
  doc.setFontSize(8);
  doc.setFont("helvetica", "italic");
  doc.setTextColor(128, 128, 128);
  const timestamp = new Date().toLocaleString();
  doc.text(`Generated: ${timestamp}`, 14, 280);
  doc.text("Eye Care Clinic & Optical", 105, 280, null, null, "center");

  // Save PDF
  doc.save(`Prescription_${patient.name.replace(/\s+/g, '_')}_${patient.appointmentNo}.pdf`);
};











const [claim, setClaim] = useState({
  jobNo: "",
  name: "",
  phone: "",
  age: "",
  prescriptionDate: "",
  referredBy: "",
  pd: "",
  sh: "",
  rightEyePower: "",
  leftEyePower: "",
  lensModel: "",
  frame: "",
  lensPrice: "",
  framePrice: ""
});

const handleClaimBillChange = (e) => {
  setClaim({ ...claim, [e.target.name]: e.target.value });
};

const saveClaimBill = async () => {
  const total =
    Number(claim.lensPrice || 0) + Number(claim.framePrice || 0);

  await addDoc(collection(db, "claimbill"), {
    ...claim,
    total,
    createdAt: Timestamp.now()
  });

  generateClaimBillPDF({ ...claim, total });
};





const generateClaimBillPDF = (data) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  // Professional color palette
  const NAVY = [0, 32, 64];          // Dark navy for headers
  const GRAY_DARK = [80, 80, 80];     // Dark gray for text
  const GRAY_LIGHT = [240, 240, 240]; // Light gray for backgrounds
  const WHITE = [255, 255, 255];
  
  const MARGIN = 20;
  const PAGE_WIDTH = 210;
  const CONTENT_WIDTH = PAGE_WIDTH - (MARGIN * 2);
  
  /* ========== HEADER ========== */
  
  // Logo on left
  try {
    doc.addImage('/optical-logo.png', 'PNG', MARGIN, 10, 25, 25);
  } catch (error) {
    // If logo fails, use text
    doc.setFontSize(16);
    doc.setTextColor(...NAVY);
    doc.setFont("helvetica", "bold");
    doc.text("EYE CARE CLINIC", MARGIN, 22);
  }
  


// Colors (NO SPREAD — SAFE)
const NAVY_R = 0, NAVY_G = 51, NAVY_B = 102;
const GRAY_R = 80, GRAY_G = 80, GRAY_B = 80;

// ===== LOGO (optional) =====
// If you have logo base64
// doc.addImage(logoBase64, "PNG", MARGIN, 12, 20, 20);

// ===== PRACTICE NAME (LEFT, NEXT TO LOGO) =====
doc.setFont("helvetica", "bold");
doc.setFontSize(16);
doc.setTextColor(NAVY_R, NAVY_G, NAVY_B);
doc.text(
  "EYE CARE CLINIC & OPTICAL",
  MARGIN + 30, // space for logo
  22
);

// ===== PRACTICE DETAILS (RIGHT ALIGNED) =====
doc.setFont("helvetica", "normal");
doc.setFontSize(9);
doc.setTextColor(GRAY_R, GRAY_G, GRAY_B);

doc.text(
  "932, Maradana Road, Colombo 08",
  PAGE_WIDTH - MARGIN,
  15,
  { align: "right" }
);

doc.text(
  "Tel: 011 268 2277",
  PAGE_WIDTH - MARGIN,
  21,
  { align: "right" }
);

doc.text(
  "Email: info@eyecare.lk",
  PAGE_WIDTH - MARGIN,
  27,
  { align: "right" }
);

// ===== DIVIDER LINE =====
doc.setDrawColor(NAVY_R, NAVY_G, NAVY_B);
doc.line(MARGIN, 32, PAGE_WIDTH - MARGIN, 32);
  
  // Separator line
  doc.setDrawColor(...GRAY_LIGHT);
  doc.setLineWidth(0.5);
  doc.line(MARGIN, 35, PAGE_WIDTH - MARGIN, 35);
  
  /* ========== TITLE AND JOB INFO ========== */
  

  
  // Job details box - clean and minimal
  doc.setFillColor(...GRAY_LIGHT);
  doc.roundedRect(PAGE_WIDTH - MARGIN - 85, 40, 85, 20, 2, 2, 'F');
  
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY_DARK);
  doc.text("Job Number:", PAGE_WIDTH - MARGIN - 80, 50);
  
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text(`${data.jobNo || 'N/A'}`, PAGE_WIDTH - MARGIN - 25, 50, { align: "right" });
  
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY_DARK);
  doc.text(`Date: ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`, PAGE_WIDTH - MARGIN - 80, 57);
  
  /* ========== PATIENT DETAILS ========== */
  
  let y = 70;
  
  // Patient section title
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text("PATIENT INFORMATION", MARGIN, y);
  
  // Add light underline
  doc.setDrawColor(...GRAY_LIGHT);
  doc.setLineWidth(0.3);
  doc.line(MARGIN, y + 1, MARGIN + 50, y + 1);
  
  y += 10;
  
  // Patient details in clean grid with proper alignment
  doc.setFontSize(10);
  doc.setTextColor(...GRAY_DARK);
  
  const col1 = MARGIN;
  const col2 = MARGIN + 95;
  const col3 = MARGIN + 145;
  
  // Row 1
  doc.setFont("helvetica", "bold");
  doc.text("Full Name:", col1, y);
  doc.setFont("helvetica", "normal");
  doc.text(data.name || "-", col1 + 25, y);
  
  doc.setFont("helvetica", "bold");
  doc.text("Age:", col2, y);
  doc.setFont("helvetica", "normal");
  doc.text(data.age || "-", col2 + 15, y);
  
  
  y += 8;
  
  // Row 2
  doc.setFont("helvetica", "bold");
  doc.text("Phone:", col1, y);
  doc.setFont("helvetica", "normal");
  doc.text(data.phone || "-", col1 + 25, y);
  
  doc.setFont("helvetica", "bold");
  doc.text("Prescription Date:", col2, y);
  doc.setFont("helvetica", "normal");
  doc.text(data.prescriptionDate || "-", col2 + 40, y);
  
  y += 8;
  
  // Row 3
  doc.setFont("helvetica", "bold");
  doc.text("Referred By:", col1, y);
  doc.setFont("helvetica", "normal");
  doc.text(data.referredBy || "-", col1 + 25, y);
  
  doc.setFont("helvetica", "bold");
  doc.text("PD / SH:", col2, y);
  doc.setFont("helvetica", "normal");
  doc.text(`${data.pd || '-'} / ${data.sh || '-'}`, col2 + 25, y);
  
  y += 15;
  
  /* ========== PRESCRIPTION TABLE ========== */
  
  // Section title
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text("PRESCRIPTION DETAILS", MARGIN, y);
  
  // Add light underline
  doc.setDrawColor(...GRAY_LIGHT);
  doc.setLineWidth(0.3);
  doc.line(MARGIN, y + 1, MARGIN + 60, y + 1);
  
  y += 10;
  
  // Table headers
  const tableStart = MARGIN;
  const tableWidth = CONTENT_WIDTH;
  const colPrescription = [tableStart, tableStart + 70, tableStart + 130];
  
  // Header background
  doc.setFillColor(...NAVY);
  doc.rect(tableStart, y - 5, tableWidth, 8, 'F');
  
  doc.setTextColor(...WHITE);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("Description", colPrescription[0] + 2, y);
  doc.text("Right Eye", colPrescription[1] + 2, y);
  doc.text("Left Eye", colPrescription[2] + 2, y);
  
  y += 8;
  
  // Table rows
  doc.setTextColor(...GRAY_DARK);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  
  const rows = [
    ["Eye Power", data.rightEyePower || "-", data.leftEyePower || "-"],
    ["Lens Model", data.lensModel || "-", ""],
    ["Frame", data.frame || "-", ""]
  ];
  
  rows.forEach((row, index) => {
    // Light gray background for alternate rows
    if (index % 2 === 1) {
      doc.setFillColor(...GRAY_LIGHT);
      doc.rect(tableStart, y - 4, tableWidth, 6, 'F');
    }
    
    doc.text(row[0], colPrescription[0] + 2, y);
    doc.text(row[1], colPrescription[1] + 2, y);
    doc.text(row[2], colPrescription[2] + 2, y);
    y += 7;
  });
  
  y += 10;
  
  /* ========== CHARGES SECTION ========== */
  
  // Section title
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text("CHARGES BREAKDOWN", MARGIN, y);
  
  // Add light underline
  doc.setDrawColor(...GRAY_LIGHT);
  doc.setLineWidth(0.3);
  doc.line(MARGIN, y + 1, MARGIN + 60, y + 1);
  
  y += 10;
  
  // Charges table with proper alignment
  const chargesLeft = MARGIN;
  const chargesRight = PAGE_WIDTH - MARGIN;
  const lineLength = 80;
  
  // Lens price row
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY_DARK);
  doc.text("Lens Price:", chargesLeft, y);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text(`Rs. ${Number(data.lensPrice || 0).toLocaleString()}`, chargesRight - 5, y, { align: "right" });
  
  y += 8;
  
  // Frame price row
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY_DARK);
  doc.text("Frame Price:", chargesLeft, y);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text(`Rs. ${Number(data.framePrice || 0).toLocaleString()}`, chargesRight - 5, y, { align: "right" });
  
  y += 8;
  
  // Subtotal line (if needed)
  if (data.discount) {
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...GRAY_DARK);
    doc.text("Subtotal:", chargesLeft, y);
    const subtotal = (Number(data.lensPrice) + Number(data.framePrice)).toLocaleString();
    doc.text(`Rs. ${subtotal}`, chargesRight - 5, y, { align: "right" });
    y += 8;
    
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...GRAY_DARK);
    doc.text("Discount:", chargesLeft, y);
    doc.text(`- Rs. ${Number(data.discount).toLocaleString()}`, chargesRight - 5, y, { align: "right" });
    y += 8;
  }
  
  // Separator line
  doc.setDrawColor(...GRAY_DARK);
  doc.setLineWidth(0.2);
  doc.line(chargesRight - lineLength, y - 2, chargesRight, y - 2);
  
  y += 5;
  
  // Total
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...NAVY);
  doc.text("TOTAL AMOUNT:", chargesLeft, y);
  doc.text(`Rs. ${Number(data.total || 0).toLocaleString()}`, chargesRight - 5, y, { align: "right" });
  
  y += 6;

  
  /* ========== FOOTER ========== */
  
  // Footer line
  doc.setDrawColor(...GRAY_LIGHT);
  doc.setLineWidth(0.5);
  doc.line(MARGIN, 250, PAGE_WIDTH - MARGIN, 250);
  
  // Footer content - three column layout
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY_DARK);
  
  // Left - Generated info
  doc.text(`Generated: ${new Date().toLocaleString()}`, MARGIN, 260);
  
  // Center - Thank you message
  doc.setFont("helvetica", "italic");
  doc.text("Thank you for choosing Eye Care Clinic", PAGE_WIDTH / 2, 260, { align: "center" });
  

  
  /* ========== TERMS ========== */
  
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY_DARK);
  
  // Add page number
  doc.text("Page 1 of 1", PAGE_WIDTH / 2, 280, { align: "center" });
  
  doc.save(`Claim_Bill_${data.jobNo || 'New'}.pdf`);
};


















// view all claim bill





   // ===============================
  // STATE MANAGEMENT
  // ===============================
  const [bills, setBills] = useState([]);
  const [selectedBill, setSelectedBill] = useState(null);

  // ===============================
  // FETCH BILLS WITH REAL-TIME UPDATES
  // ===============================
  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "claimbill"), 
      (snapshot) => {
        const billsList = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setBills(billsList);
        setLoading(false);
        setError(null);
      }, 
      (err) => {
        console.error("Error fetching bills:", err);
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  // ===============================
  // EDIT BUTTON - NO TAB CHANGE!
  // ===============================
  const handleEditBill = (bill) => {
    setSelectedBill(bill);  // Only set the selected bill, no tab change
  };

  // ===============================
  // UPDATE BILL WITH VALIDATION
  // ===============================
  const updateClaimBill = async () => {
    if (!selectedBill?.id) {
      alert("No bill selected for update");
      return;
    }

    if (!selectedBill.name?.trim() || !selectedBill.phone?.trim()) {
      alert("Name and Phone are required fields");
      return;
    }

    try {
      const updatedData = {
        jobNo: selectedBill.jobNo || "",
        name: selectedBill.name.trim(),
        phone: selectedBill.phone.trim(),
        age: selectedBill.age || "",
        frame: selectedBill.frame || "",
        framePrice: selectedBill.framePrice || "",
        lensModel: selectedBill.lensModel || "",
        lensPrice: selectedBill.lensPrice || "",
        leftEyePower: selectedBill.leftEyePower || "",
        rightEyePower: selectedBill.rightEyePower || "",
        pd: selectedBill.pd || "",
        sh: selectedBill.sh || "",
        referredBy: selectedBill.referredBy || "",
        prescriptionDate: selectedBill.prescriptionDate || "",
        total: selectedBill.total || "",
        updatedAt: new Date().toISOString()
      };

      await updateDoc(doc(db, "claimbill", selectedBill.id), updatedData);
      alert("Updated successfully ✅");
      setSelectedBill(null); // Clear selected bill after update
    } catch (error) {
      console.error("Update failed:", error);
      alert(`Update failed: ${error.message}`);
    }
  };

  // ===============================
  // DELETE BILL
  // ===============================
  const deleteClaimBill = async (billId) => {
    if (window.confirm("Are you sure you want to delete this bill?")) {
      try {
        await deleteDoc(doc(db, "claimbill", billId));
        alert("Bill deleted successfully ✅");
      } catch (error) {
        console.error("Delete failed:", error);
        alert(`Delete failed: ${error.message}`);
      }
    }
  };

  // ===============================
  // PDF GENERATION
  // ===============================
  const handleDownloadBill = (bill) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const NAVY = [0, 32, 64];
    const GRAY_DARK = [80, 80, 80];
    const GRAY_LIGHT = [240, 240, 240];
    const WHITE = [255, 255, 255];
    
    const MARGIN = 20;
    const PAGE_WIDTH = 210;
    const CONTENT_WIDTH = PAGE_WIDTH - (MARGIN * 2);
    
    let y = 10;
    
    // Header
    try {
      doc.addImage('/optical-logo.png', 'PNG', MARGIN, y, 25, 25);
    } catch (error) {
      doc.setFontSize(16);
      doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
      doc.setFont("helvetica", "bold");
      doc.text("EYE CARE CLINIC", MARGIN, y + 12);
    }
    
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.text("EYE CARE CLINIC & OPTICAL", MARGIN + 30, y + 12);
    
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(GRAY_DARK[0], GRAY_DARK[1], GRAY_DARK[2]);
    doc.text("932, Maradana Road, Colombo 08", PAGE_WIDTH - MARGIN, y + 5, { align: "right" });
    doc.text("Tel: 011 268 2277", PAGE_WIDTH - MARGIN, y + 11, { align: "right" });
    doc.text("Email: info@eyecareclinicandoptical.com", PAGE_WIDTH - MARGIN, y + 17, { align: "right" });
    
    doc.setDrawColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.line(MARGIN, y + 22, PAGE_WIDTH - MARGIN, y + 22);
    doc.setDrawColor(GRAY_LIGHT[0], GRAY_LIGHT[1], GRAY_LIGHT[2]);
    doc.line(MARGIN, y + 25, PAGE_WIDTH - MARGIN, y + 25);
    
    y = 40;
    doc.setFillColor(GRAY_LIGHT[0], GRAY_LIGHT[1], GRAY_LIGHT[2]);
    doc.roundedRect(PAGE_WIDTH - MARGIN - 85, y, 85, 20, 2, 2, 'F');
    
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(GRAY_DARK[0], GRAY_DARK[1], GRAY_DARK[2]);
    doc.text("Job Number:", PAGE_WIDTH - MARGIN - 80, y + 10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.text(`${bill.jobNo || 'N/A'}`, PAGE_WIDTH - MARGIN - 25, y + 10, { align: "right" });
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(GRAY_DARK[0], GRAY_DARK[1], GRAY_DARK[2]);
    doc.text(`Date: ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`, 
      PAGE_WIDTH - MARGIN - 80, y + 17);
    
    y = 70;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.text("PATIENT INFORMATION", MARGIN, y);
    doc.setDrawColor(GRAY_LIGHT[0], GRAY_LIGHT[1], GRAY_LIGHT[2]);
    doc.line(MARGIN, y + 1, MARGIN + 50, y + 1);
    
    y += 10;
    doc.setFontSize(10);
    doc.setTextColor(GRAY_DARK[0], GRAY_DARK[1], GRAY_DARK[2]);
    
    const col1 = MARGIN;
    const col2 = MARGIN + 95;
    
    doc.setFont("helvetica", "bold");
    doc.text("Full Name:", col1, y);
    doc.setFont("helvetica", "normal");
    doc.text(bill.name || "-", col1 + 25, y);
    doc.setFont("helvetica", "bold");
    doc.text("Age:", col2, y);
    doc.setFont("helvetica", "normal");
    doc.text(bill.age || "-", col2 + 15, y);
    
    y += 8;
    doc.setFont("helvetica", "bold");
    doc.text("Phone:", col1, y);
    doc.setFont("helvetica", "normal");
    doc.text(bill.phone || "-", col1 + 25, y);
    doc.setFont("helvetica", "bold");
    doc.text("Prescription Date:", col2, y);
    doc.setFont("helvetica", "normal");
    doc.text(bill.prescriptionDate || "-", col2 + 40, y);
    
    y += 8;
    doc.setFont("helvetica", "bold");
    doc.text("Referred By:", col1, y);
    doc.setFont("helvetica", "normal");
    doc.text(bill.referredBy || "-", col1 + 25, y);
    doc.setFont("helvetica", "bold");
    doc.text("PD / SH:", col2, y);
    doc.setFont("helvetica", "normal");
    doc.text(`${bill.pd || '-'} / ${bill.sh || '-'}`, col2 + 25, y);
    
    y += 15;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.text("PRESCRIPTION DETAILS", MARGIN, y);
    doc.line(MARGIN, y + 1, MARGIN + 60, y + 1);
    
    y += 10;
    const tableStart = MARGIN;
    const tableWidth = CONTENT_WIDTH;
    const colPrescription = [tableStart, tableStart + 70, tableStart + 130];
    
    doc.setFillColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.rect(tableStart, y - 5, tableWidth, 8, 'F');
    doc.setTextColor(WHITE[0], WHITE[1], WHITE[2]);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.text("Description", colPrescription[0] + 2, y);
    doc.text("Right Eye", colPrescription[1] + 2, y);
    doc.text("Left Eye", colPrescription[2] + 2, y);
    
    y += 8;
    doc.setTextColor(GRAY_DARK[0], GRAY_DARK[1], GRAY_DARK[2]);
    doc.setFont("helvetica", "normal");
    
    const rows = [
      ["Eye Power", bill.rightEyePower || "-", bill.leftEyePower || "-"],
      ["Lens Model", bill.lensModel || "-", ""],
      ["Frame", bill.frame || "-", ""]
    ];
    
    rows.forEach((row, index) => {
      if (index % 2 === 1) {
        doc.setFillColor(GRAY_LIGHT[0], GRAY_LIGHT[1], GRAY_LIGHT[2]);
        doc.rect(tableStart, y - 4, tableWidth, 6, 'F');
      }
      doc.text(row[0], colPrescription[0] + 2, y);
      doc.text(row[1], colPrescription[1] + 2, y);
      doc.text(row[2], colPrescription[2] + 2, y);
      y += 7;
    });
    
    y += 10;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.text("CHARGES BREAKDOWN", MARGIN, y);
    doc.line(MARGIN, y + 1, MARGIN + 60, y + 1);
    
    y += 10;
    const chargesRight = PAGE_WIDTH - MARGIN;
    
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(GRAY_DARK[0], GRAY_DARK[1], GRAY_DARK[2]);
    doc.text("Lens Price:", MARGIN, y);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.text(`Rs. ${Number(bill.lensPrice || 0).toLocaleString()}`, chargesRight - 5, y, { align: "right" });
    
    y += 8;
    doc.setFont("helvetica", "normal");
    doc.setTextColor(GRAY_DARK[0], GRAY_DARK[1], GRAY_DARK[2]);
    doc.text("Frame Price:", MARGIN, y);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.text(`Rs. ${Number(bill.framePrice || 0).toLocaleString()}`, chargesRight - 5, y, { align: "right" });
    
    y += 12;
    doc.setDrawColor(GRAY_DARK[0], GRAY_DARK[1], GRAY_DARK[2]);
    doc.setLineWidth(0.2);
    doc.line(chargesRight - 80, y - 2, chargesRight, y - 2);
    
    y += 5;
    doc.setFontSize(13);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(NAVY[0], NAVY[1], NAVY[2]);
    doc.text("TOTAL AMOUNT:", MARGIN, y);
    doc.text(`Rs. ${Number(bill.total || 0).toLocaleString()}`, chargesRight - 5, y, { align: "right" });
    
    y = 250;
    doc.setDrawColor(GRAY_LIGHT[0], GRAY_LIGHT[1], GRAY_LIGHT[2]);
    doc.line(MARGIN, y, PAGE_WIDTH - MARGIN, y);
    
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(GRAY_DARK[0], GRAY_DARK[1], GRAY_DARK[2]);
    doc.text(`Generated: ${new Date().toLocaleString()}`, MARGIN, y + 10);
    doc.setFont("helvetica", "italic");
    doc.text("Thank you for choosing Eye Care Clinic", PAGE_WIDTH / 2, y + 10, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.text("For inquiries, please contact us at 011 268 2277", PAGE_WIDTH / 2, y + 17, { align: "center" });
    doc.text("Page 1 of 1", PAGE_WIDTH / 2, y + 24, { align: "center" });
    
    doc.save(`Claim_Bill_${bill.jobNo || 'New'}.pdf`);
  };






////////////////////////////////// patient foolow ups - save status after the deadline ////////////////////////////////////////////////




useEffect(() => {
  const statusMap = {};

  patients.forEach((p) => {
    statusMap[p.id] = p.followupStatus || [];
  });

  setFollowupStatus(statusMap);
}, [patients]);







////////////////////////////////////////////////////
const [visitFilter, setVisitFilter] = useState("all");





  return (
    <div className="admin-panel">
      <div className="top-bar">
        <ul className="tabs">

              <li className={`tab ${activeTab === 'createPrescription' ? 'active' : ''}`} onClick={() => handleTabClick('createPrescription')}>
                Create Prescription
              </li>

              <li className={`tab ${activeTab === 'viewAllPrescription' ? 'active' : ''}`} onClick={() => handleTabClick('viewAllPrescription')}>
                View Prescriptions
              </li>

              <li className={`tab ${activeTab === 'claimbill' ? 'active' : ''}`} onClick={() => handleTabClick('claimbill')}>
                Claim bill
              </li>


              <li className={`tab ${activeTab === 'Viewclaimbill' ? 'active' : ''}`} onClick={() => handleTabClick('Viewclaimbill')}>
                View Claim bill
              </li>



              <li className={`tab ${activeTab === 'addPatient' ? 'active' : ''}`} onClick={() => handleTabClick('addPatient')}>
                Add Patient
              </li>


              <li className={`tab ${activeTab === 'viewAllPatients' ? 'active' : ''}`} onClick={() => handleTabClick('viewAllPatients')}>
                View All Patients
              </li>


              <li className={`tab ${activeTab === 'followups' ? 'active' : ''}`} onClick={() => handleTabClick('followups')}>
                Follow-Ups
              </li>


              <li className={`tab ${activeTab === 'specsRepair' ? 'active' : ''}`} onClick={() => handleTabClick('specsRepair')}>
                Specs Repair
              </li>


              <li className={`tab ${activeTab === 'viewallrepair' ? 'active' : ''}`} onClick={() => handleTabClick('viewallrepair')}>
                  View all repair
              </li>
             


              <li className={`tab ${activeTab === 'addLoyaltyCustomer' ? 'active' : ''}`} onClick={() => handleTabClick('addLoyaltyCustomer')}>
                Add Loyalty Customer
              </li>


              <li className={`tab ${activeTab === 'viewAllLoyaltyBase' ? 'active' : ''}`} onClick={() => handleTabClick('viewAllLoyaltyBase')}>
                View All Loyalty Customers
              </li>



          <li className={`tab ${activeTab === 'feedbacks' ? 'active' : ''}`} onClick={() => handleTabClick('feedbacks')}>
            Feedbacks
          </li>


          {/* <li className={`tab ${activeTab === 'contactMessage' ? 'active' : ''}`} onClick={() => handleTabClick('contactMessage')}>
            Contact Us Messages
          </li> */}

        </ul>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="main-content">


{/********************************************** customer directory ******************************************************/}


{activeTab === "claimbill" && (
  <div className="claimbill-form">
    <h2>Claim Bill</h2>

    <div className="form-group">
      <label>Job No</label>
      <input name="jobNo" onChange={handleClaimBillChange} />
    </div>

    <div className="form-group">
      <label>Patient Name</label>
      <input name="name" onChange={handleClaimBillChange} />
    </div>

    <div className="form-group">
      <label>Telephone No</label>
      <input name="phone" onChange={handleClaimBillChange} />
    </div>

    <div className="form-group">
      <label>Age</label>
      <input name="age" type="number" onChange={handleClaimBillChange} />
    </div>

    <div className="form-group">
      <label>Prescription Date</label>
      <input
        type="date"
        name="prescriptionDate"
        onChange={handleClaimBillChange}
      />
    </div>

    <div className="form-group">
      <label>Referred By</label>
      <input name="referredBy" onChange={handleClaimBillChange} />
    </div>

    <div className="form-group">
      <label>PD</label>
      <input name="pd" onChange={handleClaimBillChange} />
    </div>

    <div className="form-group">
      <label>SH</label>
      <input name="sh" onChange={handleClaimBillChange} />
    </div>

    <div className="form-group">
      <label>Right Eye Power</label>
      <input name="rightEyePower" onChange={handleClaimBillChange} />
    </div>

    <div className="form-group">
      <label>Left Eye Power</label>
      <input name="leftEyePower" onChange={handleClaimBillChange} />
    </div>

    <div className="form-group">
      <label>Lens Model</label>
      <input name="lensModel" onChange={handleClaimBillChange} />
    </div>

    <div className="form-group">
      <label>Frame</label>
      <input name="frame" onChange={handleClaimBillChange} />
    </div>

    <div className="form-group">
      <label>Lens Price (Rs.)</label>
      <input name="lensPrice" onChange={handleClaimBillChange} />
    </div>

    <div className="form-group">
      <label>Frame Price (Rs.)</label>
      <input name="framePrice" onChange={handleClaimBillChange} />
    </div>

    <button onClick={saveClaimBill}>
      Save & Generate Bill
    </button>
  </div>
)}

{/****************************************************************************************************************************/}










{/****************************************************************************************************************************/}
{activeTab === "viewAllPrescription" && (
   <div className="view-prescription-container">
      <h3>All Prescriptions</h3>

      <div className="table-wrapper">
        <table className="prescription-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Appointment No</th>
              <th>Patient Name</th>
              <th>Age</th>
              <th>Contact</th>
              <th>Hb RX</th>
              <th>RX</th>
              <th>Remarks</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {prescriptions.map((p) => (
              <tr key={p.id}>
                <td>{p.patient.date}</td>
                <td>{p.patient.appointmentNo}</td>
                <td>{p.patient.name}</td>
                <td>{p.patient.age}</td>
                <td>{p.patient.contact}</td>

                <td>
                  OD: {p.hbRx.right.sph}/{p.hbRx.right.cyl}  
                  <br />
                  OS: {p.hbRx.left.sph}/{p.hbRx.left.cyl}
                </td>

                <td>
                  OD: {p.rx.right.sph}/{p.rx.right.cyl}  
                  <br />
                  OS: {p.rx.left.sph}/{p.rx.left.cyl}
                </td>

                <td>{p.patient.remark || "-"}</td>

                <td className="action-col">
                  <button
                    className="download-btn"
                    onClick={() => generatePrescriptionPDF(p.patient, p)}
                  >
                    Download
                  </button>

                  <button
                    className="delete-btn"
                    onClick={() => handlePrescriptionDelete(p.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
)}

{/**************************************************************************************************************************/}
{activeTab === "specsRepair" && (
  <div className="specs-repair-container">
    <h3>Specs Repair</h3>

    <form onSubmit={handleSpecsRepairSubmit} className="specs-repair-form">
      <input
        type="text"
        placeholder="Job No"
        value={jobNo}
        onChange={(e) => setJobNo(e.target.value)}
        required
      />

      <input
        type="text"
        placeholder="Customer Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />

      <input
        type="text"
        placeholder="Contact Number"
        value={contact}
        onChange={(e) => setContact(e.target.value)}
        required
      />

      <textarea
        placeholder="Issue Description"
        value={issue}
        onChange={(e) => setIssue(e.target.value)}
        required
      />

      <input
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        required
      />

      <select
        value={status}
        onChange={(e) => setStatus(e.target.value)}
        required
      >
        <option value="">Select Status</option>
        <option value="pending">Pending</option>
        <option value="in progress">In Progress</option>
        <option value="completed">Completed</option>
      </select>

     <button type="submit" disabled={isSubmitting}>
      {isSubmitting ? "Saving..." : "Save Repair Job"}
    </button>

    </form>
  </div>
)}


{/****************************************************** view all repair ************************************************************************/}


 {/* ===============================
          VIEW CLAIM BILL TABLE
      =============================== */}
     {activeTab === "Viewclaimbill" && (
  <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      {/* Error Display */}
      {error && (
        <div style={{
          backgroundColor: '#ffebee',
          color: '#c62828',
          padding: '10px',
          borderRadius: '4px',
          marginBottom: '20px',
          borderLeft: '4px solid #c62828'
        }}>
          ⚠️ Error: {error}
        </div>
      )}

      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px'
      }}>
        <h2>Total Bills: {bills.length}</h2>
        <button 
          onClick={() => window.location.reload()}
          style={{
            padding: '8px 16px',
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          🔄 Refresh
        </button>
      </div>

      {/* Loading State */}
      {loading && (
        <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
          <p>Loading bills...</p>
        </div>
      )}

      {/* Empty State */}
      {!loading && bills.length === 0 && (
        <div style={{
          textAlign: 'center',
          padding: '40px',
          color: '#666',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px'
        }}>
          <p>📋 No bills found</p>
        </div>
      )}

      {/* Main Table - ALWAYS VISIBLE */}
      {!loading && bills.length > 0 && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            backgroundColor: 'white',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#1976D2', color: 'white' }}>
                <th style={{ padding: '12px', textAlign: 'left' }}>No</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Job No</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Name</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Phone</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Frame</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Lens</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Total</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Prescription Date</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Created Date</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {bills.map((bill, index) => (
                <tr 
                  key={bill.id} 
                  style={{
                    borderBottom: '1px solid #e0e0e0',
                    backgroundColor: selectedBill?.id === bill.id ? '#fff3e0' : 'transparent'
                  }}
                >
                  <td style={{ padding: '10px' }}>{index + 1}</td>

                  {/* Job No */}
                  <td style={{ padding: '10px' }}>
                    {selectedBill?.id === bill.id ? (
                      <input
                        value={selectedBill.jobNo || ""}
                        onChange={(e) =>
                          setSelectedBill({ ...selectedBill, jobNo: e.target.value })
                        }
                        style={{
                          padding: '6px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          width: '100%'
                        }}
                      />
                    ) : (
                      bill.jobNo || "-"
                    )}
                  </td>

                  {/* Name */}
                  <td style={{ padding: '10px' }}>
                    {selectedBill?.id === bill.id ? (
                      <input
                        value={selectedBill.name || ""}
                        onChange={(e) =>
                          setSelectedBill({ ...selectedBill, name: e.target.value })
                        }
                        style={{
                          padding: '6px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          width: '100%'
                        }}
                      />
                    ) : (
                      bill.name || "-"
                    )}
                  </td>

                  {/* Phone */}
                  <td style={{ padding: '10px' }}>
                    {selectedBill?.id === bill.id ? (
                      <input
                        value={selectedBill.phone || ""}
                        onChange={(e) =>
                          setSelectedBill({ ...selectedBill, phone: e.target.value })
                        }
                        style={{
                          padding: '6px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          width: '100%'
                        }}
                      />
                    ) : (
                      bill.phone || "-"
                    )}
                  </td>

                  {/* Frame */}
                  <td style={{ padding: '10px' }}>
                    {selectedBill?.id === bill.id ? (
                      <input
                        value={selectedBill.frame || ""}
                        onChange={(e) =>
                          setSelectedBill({ ...selectedBill, frame: e.target.value })
                        }
                        style={{
                          padding: '6px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          width: '100%'
                        }}
                      />
                    ) : (
                      bill.frame || "-"
                    )}
                  </td>

                  {/* Lens */}
                  <td style={{ padding: '10px' }}>
                    {selectedBill?.id === bill.id ? (
                      <input
                        value={selectedBill.lensModel || ""}
                        onChange={(e) =>
                          setSelectedBill({ ...selectedBill, lensModel: e.target.value })
                        }
                        style={{
                          padding: '6px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          width: '100%'
                        }}
                      />
                    ) : (
                      bill.lensModel || "-"
                    )}
                  </td>

                  {/* Total */}
                  <td style={{ padding: '10px', fontWeight: 'bold', color: '#2e7d32' }}>
                    {selectedBill?.id === bill.id ? (
                      <input
                        value={selectedBill.total || ""}
                        onChange={(e) =>
                          setSelectedBill({ ...selectedBill, total: e.target.value })
                        }
                        type="number"
                        style={{
                          padding: '6px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          width: '100%'
                        }}
                      />
                    ) : (
                      `Rs.${bill.total || 0}`
                    )}
                  </td>

                  {/* Prescription Date */}
                  <td style={{ padding: '10px' }}>
                    {selectedBill?.id === bill.id ? (
                      <input
                        type="date"
                        value={selectedBill.prescriptionDate || ""}
                        onChange={(e) =>
                          setSelectedBill({ ...selectedBill, prescriptionDate: e.target.value })
                        }
                        style={{
                          padding: '6px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          width: '100%'
                        }}
                      />
                    ) : (
                      bill.prescriptionDate || "-"
                    )}
                  </td>

                  {/* Created Date */}
                  <td style={{ padding: '10px' }}>
                    {bill.createdAt?.toDate ? 
                      bill.createdAt.toDate().toLocaleDateString() : 
                      bill.createdAt || "-"}
                  </td>

                  {/* Action Buttons */}
                  <td style={{ padding: '10px' }}>
                    {selectedBill?.id === bill.id ? (
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button
                          onClick={updateClaimBill}
                          style={{
                            padding: '5px 10px',
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                          }}
                        >
                          💾 Save
                        </button>
                        <button
                          onClick={() => setSelectedBill(null)}
                          style={{
                            padding: '5px 10px',
                            backgroundColor: '#ff9800',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                          }}
                        >
                          ❌ Cancel
                        </button>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        <button
                          onClick={() => handleEditBill(bill)}
                          style={{
                            padding: '5px 10px',
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                          }}
                        >
                          ✏️ Edit
                        </button>
                        <button
                          onClick={() => handleDownloadBill(bill)}
                          style={{
                            padding: '5px 10px',
                            backgroundColor: '#2196F3',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                          }}
                        >
                          📥 Download
                        </button>
                        <button
                          onClick={() => deleteClaimBill(bill.id)}
                          style={{
                            padding: '5px 10px',
                            backgroundColor: '#f44336',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                          }}
                        >
                          🗑️ Delete
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
)}










{/*************************************************************************************************/}


{activeTab === "createPrescription" && (
  <div className="create-prescription-container">

<div className="create-prescription-container">
      <h3>Create Prescription</h3>

      {/* Patient Info */}
      <h4>Patient Information</h4>
<div className="patient-grid">

  <div className="form-group">
    <label>Date</label>
    <input
      type="date"
      onChange={(e) =>
        handlePrescriptionChange("date", e.target.value)
      }
    />
  </div>

  <div className="form-group">
    <label>Appointment No</label>
    <input
      type="text"
      placeholder="AP-001"
      onChange={(e) =>
        handlePrescriptionChange("appointmentNo", e.target.value)
      }
    />
  </div>

  <div className="form-group">
    <label>Patient Name</label>
    <input
      type="text"
      placeholder="Full Name"
      onChange={(e) =>
        handlePrescriptionChange("name", e.target.value)
      }
    />
  </div>

  <div className="form-group">
    <label>Age</label>
    <input
      type="number"
      placeholder="Years"
      onChange={(e) =>
        handlePrescriptionChange("age", e.target.value)
      }
    />
  </div>

  <div className="form-group">
    <label>Date of Birth</label>
    <input
      type="date"
      onChange={(e) =>
        handlePrescriptionChange("dob", e.target.value)
      }
    />
  </div>

  <div className="form-group">
    <label>Contact No</label>
    <input
      type="tel"
      placeholder="07X XXX XXXX"
      onChange={(e) =>
        handlePrescriptionChange("contact", e.target.value)
      }
    />
  </div>

  <div className="form-group full-width">
    <label>Address</label>
    <textarea
      rows="2"
      placeholder="Residential Address"
      onChange={(e) =>
        handlePrescriptionChange("address", e.target.value)
      }
    />
  </div>

</div>


{/* RX Tables */}
{["hbRx", "rx"].map((section) => (
  <div key={section} className="rx-section">

    <h4 className="rx-title">
      {section === "hbRx"
        ? "Hb RX"
        : "RX"}
    </h4>

    <table className="rx-table">
      <thead>
        <tr>
          <th>Eye</th>
          <th>SPH</th>
          <th>CYL</th>
          <th>Axis</th>
          <th>Add</th>
        </tr>
      </thead>

      <tbody>
        {["right", "left"].map((eye) => (
          <tr key={eye}>
            <td className="eye-label">
              {eye === "right" ? "Right (OD)" : "Left (OS)"}
            </td>

            {["sph", "cyl", "axis", "add"].map((field) => (
              <td key={field}>
                <input
                  type="text"
                  placeholder={field.toUpperCase()}
                  onChange={(e) =>
                    handleRxChange(section, eye, field, e.target.value)
                  }
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>


  <div className="form-group">
    <label>Remark </label>
    <input
      type="text"
      placeholder="Remark "
      onChange={(e) =>
        handlePrescriptionChange("remark", e.target.value)
      }
    />
  </div>
  </div>
))}


<button className="save-btn" onClick={savePrescription}>
  Save & Download
</button>

<br/><br/>

    </div>
    </div>
)}



{/******************************************************************************************************************************/}


{activeTab === "addPatient" && (
  <div className="add-patient-container">
    <h3 className="add-patient-heading">Add Patient</h3>

    <form onSubmit={handlePatientSubmit} className="add-patient-form">
      
      {/* Patient Name */}
      <div className="add-patient-formgroup">
        <label htmlFor="name">Patient Name</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handlePatientChange}
          required
        />
      </div>

      {/* Gender */}
      <div className="add-patient-formgroup">
        <label htmlFor="gender">Gender</label>
        <select
          id="gender"
          name="gender"
          value={formData.gender}
          onChange={handlePatientChange}
          required
        >
          <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>
      </div>

      {/* Age */}
      <div className="add-patient-formgroup">
        <label htmlFor="age">Age</label>
        <input
          type="number"
          id="age"
          name="age"
          value={formData.age}
          onChange={handlePatientChange}
          required
        />
      </div>

      {/* Date of Birth */}
      <div className="add-patient-formgroup">
        <label htmlFor="dob">Date of Birth</label>
        <input
          type="date"
          id="dob"
          name="dob"
          value={formData.dob}
          onChange={handlePatientChange}
          required
        />
      </div>

      {/* Contact Number */}
      <div className="add-patient-formgroup">
        <label htmlFor="contact">Contact Number</label>
        <input
          type="text"
          id="contact"
          name="contact"
          value={formData.contact}
          onChange={handlePatientChange}
          required
        />
      </div>

      {/* Address */}
      <div className="add-patient-formgroup full-width">
        <label htmlFor="address">Address</label>
        <input
          type="text"
          id="address"
          name="address"
          value={formData.address}
          onChange={handlePatientChange}
        />
      </div>

      {/* Prescribed Date */}
      <div className="add-patient-formgroup">
        <label htmlFor="prescribedDate">Prescribed Date</label>
        <input
          type="date"
          id="prescribedDate"
          name="prescribedDate"
          value={formData.prescribedDate}
          onChange={handlePatientChange}
          required
        />
      </div>

      {/* Follow Up Date */}
      <div className="add-patient-formgroup">
        <label htmlFor="followUpDate">Follow Up Date</label>
        <input
          type="date"
          id="followUpDate"
          name="followUpDate"
          value={formData.followUpDate}
          onChange={handlePatientChange}
        />
      </div>

      {/* Prescription Old */}
      <div className="add-patient-formgroup full-width">
        <label htmlFor="prescriptionOld">Old Prescription</label>
        <textarea
          id="prescriptionOld"
          name="prescriptionOld"
          value={formData.prescriptionOld}
          onChange={handlePatientChange}
        />
      </div>

      {/* Prescription New */}
      <div className="add-patient-formgroup full-width">
        <label htmlFor="prescriptionNew">New Prescription</label>
        <textarea
          id="prescriptionNew"
          name="prescriptionNew"
          value={formData.prescriptionNew}
          onChange={handlePatientChange}
        />
      </div>

      {/* Special Disease */}
      <div className="add-patient-formgroup full-width">
        <label htmlFor="specialDisease">Special Disease</label>
        <input
          type="text"
          id="specialDisease"
          name="specialDisease"
          value={formData.specialDisease}
          onChange={handlePatientChange}
        />
      </div>

      {/* Lens Type */}
      <div className="add-patient-formgroup full-width">
        <label htmlFor="lensType">Lens Type</label>
        <input
          type="text"
          id="lensType"
          name="lensType"
          value={formData.lensType}
          onChange={handlePatientChange}
        />
      </div>

      {/* Submit */}
      <div className="add-patient-formgroup full-width">
        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : "Save Patient"}
        </button>
      </div>
    </form>



{/* Success alert */}
{successMsg && (
  <div className="success-alert">
    {successMsg}
  </div>
)}

  </div>
)}








{/******************************************************************************************************************************/}

{activeTab === "viewAllPatients" && (
  <div className="viewAllPatients-container">
    <h3 className="heading-view-all-patients">View All Patients</h3>

    {/* ✅ Alert Messages */}
    {alertMessage && (
      <div
        className={`alert ${
          alertMessage.type === "success" ? "alert-success" : "alert-delete"
        }`}
      >
        {alertMessage.text}
      </div>
    )}

    {/* ✅ Search & Filter Section */}
    <div className="filters">
      <input
        type="text"
        placeholder="Search by name or phone..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <select value={filterYear} onChange={(e) => setFilterYear(e.target.value)}>
        <option value="">All Years</option>
        {[...Array(20)].map((_, i) => {
          const year = 2020 + i;
          return (
            <option key={year} value={year}>
              {year}
            </option>
          );
        })}
      </select>

      <select
        value={filterMonth}
        onChange={(e) => setFilterMonth(e.target.value)}
      >
        <option value="">All Months</option>
        {[
          "01-January",
          "02-February",
          "03-March",
          "04-April",
          "05-May",
          "06-June",
          "07-July",
          "08-August",
          "09-September",
          "10-October",
          "11-November",
          "12-December",
        ].map((m) => {
          const [val, label] = m.split("-");
          return (
            <option key={val} value={val}>
              {label}
            </option>
          );
        })}
      </select>
    </div>

    {/* ✅ Patients Table */}
    <table className="viewAllPatients-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Gender</th>
          <th>Age</th>
          <th>DOB</th>
          <th>Contact</th>
          <th>Address</th>
          <th>Prescribed Date</th>
          <th>Old Prescription</th>
          <th>New Prescription</th>
          <th>Special Disease</th>
          <th>Lens Type</th>
          <th>Follow Up</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {filteredPatients.map((patient) => (
          <React.Fragment key={patient.id}>
            {editPatientId === patient.id ? (
              <tr>
                {/* Editable Row */}
                <td colSpan="13">
                  <form
                    className="edit-patient-form"
                    onSubmit={(e) => handlePatientSaveEdit(e, patient.id)}
                  >
                    <div className="edit-form-grid">
                      <label>
                        Name
                        <input
                          type="text"
                          name="name"
                          value={editFormData.name}
                          onChange={handlePatientEditChange}
                          required
                        />
                      </label>
                      <label>
                        Gender
                        <select
                          name="gender"
                          value={editFormData.gender}
                          onChange={handlePatientEditChange}
                          required
                        >
                          <option value="">Select</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </label>
                      <label>
                        Age
                        <input
                          type="number"
                          name="age"
                          value={editFormData.age}
                          onChange={handlePatientEditChange}
                          required
                        />
                      </label>
                      <label>
                        Date of Birth
                        <input
                          type="date"
                          name="dob"
                          value={editFormData.dob}
                          onChange={handlePatientEditChange}
                          required
                        />
                      </label>
                      <label>
                        Contact
                        <input
                          type="text"
                          name="contact"
                          value={editFormData.contact}
                          onChange={handlePatientEditChange}
                          required
                        />
                      </label>
                      <label className="full-width">
                        Address
                        <input
                          type="text"
                          name="address"
                          value={editFormData.address}
                          onChange={handlePatientEditChange}
                        />
                      </label>
                      <label>
                        Prescribed Date
                        <input
                          type="date"
                          name="prescribedDate"
                          value={editFormData.prescribedDate}
                          onChange={handlePatientEditChange}
                          required
                        />
                      </label>
                      <label>
                        Follow Up Date
                        <input
                          type="date"
                          name="followUpDate"
                          value={editFormData.followUpDate}
                          onChange={handlePatientEditChange}
                        />
                      </label>
                      <label className="full-width">
                        Old Prescription
                        <textarea
                          name="prescriptionOld"
                          value={editFormData.prescriptionOld}
                          onChange={handlePatientEditChange}
                        />
                      </label>
                      <label className="full-width">
                        New Prescription
                        <textarea
                          name="prescriptionNew"
                          value={editFormData.prescriptionNew}
                          onChange={handlePatientEditChange}
                        />
                      </label>
                      <label className="full-width">
                        Special Disease
                        <input
                          type="text"
                          name="specialDisease"
                          value={editFormData.specialDisease}
                          onChange={handlePatientEditChange}
                        />
                      </label>
                      <label className="full-width">
                        Lens Type
                        <input
                          type="text"
                          name="lensType"
                          value={editFormData.lensType}
                          onChange={handlePatientEditChange}
                        />
                      </label>
                    </div>
                    <div className="edit-actions">
                      <button type="submit" className="btn-save">
                        Save
                      </button>
                      <button
                        type="button"
                        className="btn-cancel"
                        onClick={handlePatientCancelEdit}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </td>
              </tr>
            ) : (
              <tr>
                <td>{patient.name}</td>
                <td>{patient.gender}</td>
                <td>{patient.age}</td>
                <td>{patient.dob}</td>
                <td>{patient.contact}</td>
                <td>{patient.address}</td>
                <td>{patient.prescribedDate}</td>
                <td>{patient.prescriptionOld}</td>
                <td>{patient.prescriptionNew}</td>
                <td>{patient.specialDisease}</td>
                <td>{patient.lensType}</td>
                <td>{patient.followUpDate}</td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="btn-edit"
                      onClick={() => handlePatientEditClick(patient)}
                    >
                      <span>&#9998;</span>
                    </button>
                    <button
                      className="btn-delete"
                      onClick={() => handlePatientDelete(patient.id)}
                    >
                      <span>&#x1F5D1;</span>
                    </button>
                  </div>
                </td>
              </tr>
            )}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  </div>
)}




{/****************************************************** patient follow ups************************************************************************/}
 
{/* 
{activeTab === 'followups' && (
  <div className="followups-container">
    <div className="followups-header">
      <h3 className="heading-followups">Upcoming Follow-ups</h3>
      <span className="today-count">
        Today:{" "}
        {
          patients.filter((p) => {
            if (!p.followUpDate) return false;
            const today = new Date();
            const followUpDate = new Date(p.followUpDate);
            return (
              followUpDate.getFullYear() === today.getFullYear() &&
              followUpDate.getMonth() === today.getMonth() &&
              followUpDate.getDate() === today.getDate()
            );
          }).length
        }
      </span>
    </div>

    <div className="followups-list">
      {patients
        .filter((p) => {
          if (!p.followUpDate) return false;
          const followUpDate = new Date(p.followUpDate);
          const today = new Date();
          const daysRemaining = Math.ceil(
            (followUpDate - today) / (1000 * 60 * 60 * 24)
          );
          return daysRemaining >= 0; // hide overdue
        })
        .map((p) => {
          const followUpDate = new Date(p.followUpDate);
          const today = new Date();
          const daysRemaining = Math.ceil(
            (followUpDate - today) / (1000 * 60 * 60 * 24)
          );

          return {
            ...p,
            followUpDate,
            daysRemaining,
          };
        })
        .sort((a, b) => a.daysRemaining - b.daysRemaining) // soonest first
        .map((patient) => {
          const formattedDate = patient.followUpDate.toLocaleDateString(
            "en-US",
            {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            }
          );

          let urgencyClass = "";
          if (patient.daysRemaining <= 3) urgencyClass = "red";
          else if (patient.daysRemaining <= 10) urgencyClass = "orange";
          else if (patient.daysRemaining <= 20) urgencyClass = "green";

          return (
            <div key={patient.id} className={`followup-item ${urgencyClass}`}>
              <div className="followup-left">
                <h4 className="patient-name">{patient.name}</h4>
                <p className="contact">📞 {patient.contact}</p>
              </div>

              <div className="followup-right">
                <p className="followup-date">📅 {formattedDate}</p>
                <span className="days-remaining">
                  {patient.daysRemaining === 0
                    ? "📌 Today"
                    : `⏳ ${patient.daysRemaining} days`}
                </span>
              </div>
            </div>
          );
        })}
    </div>
  </div>
)} */}


{/******************************************* patient follow-ups ***********************************************/}






{activeTab === "followups" && (
  <div className="followups-container">

    <div className="followup-filter">
  <label>Filter:</label>

  <select
    value={visitFilter}
    onChange={(e) => setVisitFilter(e.target.value)}
  >
    <option value="all">All</option>
    <option value="Visited">Visited</option>
    <option value="notVisited">Not Visited</option>
  </select>
</div>





    {/* OVERDUE FOLLOWUPS */}
    <div className="overdue-container">
      <h3 className="heading-followups">⚠ Follow-ups (Date Passed)</h3>

      {patients
  .filter((p) => {
    if (!p.followUpDate) return false;

    const followUpDate = new Date(p.followUpDate);
    const today = new Date();

    if (followUpDate >= today) return false;

    const statuses = followupStatus[p.id] || [];
    const visited = statuses.some(
      (s) => s.text === "Made Appointment"
    );

    if (visitFilter === "Visited") return visited;
    if (visitFilter === "notVisited") return !visited;

    return true;
  })


        .map((patient) => (
          <div key={patient.id} className="overdue-card">

<div className="overdue-header">
  <div>
    <h4>{patient.name}</h4>
    <p>📞 {patient.contact}</p>
  </div>

  <div className="overdue-date">
    <p>
      📅 {new Date(patient.followUpDate).toLocaleDateString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      })}
    </p>
  </div>
</div>

            {/* STATUS SELECT */}
            <select
              value={statusInput[patient.id] || ""}
              onChange={(e) =>
                setStatusInput({
                  ...statusInput,
                  [patient.id]: e.target.value,
                })
              }
            >
              <option value="">Select Status</option>
              <option value="Call & Followed-up">Call & Followed-up</option>
              <option value="Not Answered">Not Answered</option>
              <option value="Made Appointment">Made Appointment</option>
              <option value="Visited">Visited Clinic</option>
              
            </select>



<button
  className="add-status-btn"
  onClick={async () => {
    if (!statusInput[patient.id]) return;

    const newStatus = {
      text: statusInput[patient.id],
      date: new Date().toLocaleString(),
    };

    const updatedStatuses = [
      ...(followupStatus[patient.id] || []),
      newStatus,
    ];

    try {
      const patientRef = doc(db, "patients", patient.id);

      await updateDoc(patientRef, {
        followupStatus: updatedStatuses,
      });

      setFollowupStatus({
        ...followupStatus,
        [patient.id]: updatedStatuses,
      });

      setStatusInput({
        ...statusInput,
        [patient.id]: "",
      });

    } catch (error) {
      console.error("Error saving status:", error);
    }
  }}
>
  Add Status
</button>



            {/* STATUS HISTORY */}
            <div className="status-history">
              {(followupStatus[patient.id] || []).map((s, index) => (
                <div key={index} className="status-item">

                  <span>
                    {s.text} — {s.date}
                  </span>





<button
  className="edit-btn"
  onClick={async () => {
    const newText = prompt("Edit Status", s.text);
    if (!newText) return;

    const updated = [...followupStatus[patient.id]];
    updated[index].text = newText;

    try {
      const patientRef = doc(db, "patients", patient.id);

      await updateDoc(patientRef, {
        followupStatus: updated,
      });

      setFollowupStatus({
        ...followupStatus,
        [patient.id]: updated,
      });

    } catch (error) {
      console.error("Error updating status:", error);
    }
  }}
>
  Edit
</button>








<button
  className="delete-btn"
  onClick={async () => {

    const updated = followupStatus[patient.id].filter(
      (_, i) => i !== index
    );

    try {
      const patientRef = doc(db, "patients", patient.id);

      await updateDoc(patientRef, {
        followupStatus: updated,
      });

      setFollowupStatus({
        ...followupStatus,
        [patient.id]: updated,
      });

    } catch (error) {
      console.error("Error deleting status:", error);
    }

  }}
>
  Delete
</button>





                </div>
              ))}
            </div>

          </div>
        ))}
    </div>


{/* UPCOMING FOLLOWUPS */}
<div className="followups-header">
  <h3 className="heading-followups">Upcoming Follow-ups</h3>
</div>

<div className="followups-list">
  {patients
    .filter((p) => {
      if (!p.followUpDate) return false;

      const followUpDate = new Date(p.followUpDate);
      const today = new Date();

      const daysRemaining = Math.ceil(
        (followUpDate - today) / (1000 * 60 * 60 * 24)
      );

      return daysRemaining >= 0;
    })

    // SORT BY NEAREST FOLLOWUP
    .sort((a, b) => new Date(a.followUpDate) - new Date(b.followUpDate))

    .map((patient) => {

      const followUpDate = new Date(patient.followUpDate);
      const today = new Date();

      const daysRemaining = Math.ceil(
        (followUpDate - today) / (1000 * 60 * 60 * 24)
      );

      const formattedDate = followUpDate.toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      // COLOR LOGIC
      let colorClass = "";

      if (daysRemaining <= 3) {
        colorClass = "followup-red";
      } else if (daysRemaining <= 7) {
        colorClass = "followup-yellow";
      } else {
        colorClass = "followup-green";
      }

      return (
        <div key={patient.id} className={`followup-item ${colorClass}`}>

          <div className="followup-left">
            <p><b>{patient.name}</b></p>
            <p>📞 {patient.contact}</p>
            <p>📅 {formattedDate}</p>

            <span>
              {daysRemaining === 0
                ? "📌 Today"
                : `⏳ ${daysRemaining} days`}
            </span>
          </div>

          {/* STATUS SELECT */}
          <div className="followup-right">

            <select
              value={statusInput[patient.id] || ""}
              onChange={(e) =>
                setStatusInput({
                  ...statusInput,
                  [patient.id]: e.target.value,
                })
              }
            >
              <option value="">Select Status</option>
              <option value="Call & Followed-up">Call & Followed-up</option>
              <option value="Not Answered">Not Answered</option>
              <option value="Made Appointment">Made Appointment</option>
              <option value="Visited Clinic">Visited Clinic</option>
            </select>

            <button
              className="add-status-btn"
              onClick={async () => {
                if (!statusInput[patient.id]) return;

                const newStatus = {
                  text: statusInput[patient.id],
                  date: new Date().toLocaleString(),
                };

                const updatedStatuses = [
                  ...(followupStatus[patient.id] || []),
                  newStatus,
                ];

                try {
                  const patientRef = doc(db, "patients", patient.id);

                  await updateDoc(patientRef, {
                    followupStatus: updatedStatuses,
                  });

                  setFollowupStatus({
                    ...followupStatus,
                    [patient.id]: updatedStatuses,
                  });

                  setStatusInput({
                    ...statusInput,
                    [patient.id]: "",
                  });

                } catch (error) {
                  console.error("Error saving status:", error);
                }
              }}
            >
              Add Status
            </button>

            {/* STATUS HISTORY */}
            <div className="status-history">
              {(followupStatus[patient.id] || []).map((s, index) => (
                <div key={index} className="status-item">
                  <span>
                    {s.text} — {s.date}
                  </span>

                  {/* EDIT */}
                  <button
                    className="edit-btn"
                    onClick={async () => {
                      const newText = prompt("Edit Status", s.text);
                      if (!newText) return;

                      const updated = [...followupStatus[patient.id]];
                      updated[index].text = newText;

                      const patientRef = doc(db, "patients", patient.id);

                      await updateDoc(patientRef, {
                        followupStatus: updated,
                      });

                      setFollowupStatus({
                        ...followupStatus,
                        [patient.id]: updated,
                      });
                    }}
                  >
                    Edit
                  </button>

                  {/* DELETE */}
                  <button
                    className="delete-btn"
                    onClick={async () => {
                      const updated = followupStatus[patient.id].filter(
                        (_, i) => i !== index
                      );

                      const patientRef = doc(db, "patients", patient.id);

                      await updateDoc(patientRef, {
                        followupStatus: updated,
                      });

                      setFollowupStatus({
                        ...followupStatus,
                        [patient.id]: updated,
                      });
                    }}
                  >
                    Delete
                  </button>
                </div>
              ))}
            </div>

          </div>
        </div>
      );
    })}
</div>


  </div>
)}




{/************************************************************** feedbacks ****************************************************************/}



 {activeTab === "feedbacks" && (
        <div className="feedback-container">
          <h3 className="heading-feedback">Feedbacks</h3>
          {feedbacks.length === 0 ? (
            <p>No feedbacks yet.</p>
          ) : (
            <ul className="feedback-list">
              {feedbacks.map((fb) => (
                <li key={fb.id} className="feedback-item">
                  <p className="feedback-text">{fb.feedback}</p>
                  <span className="feedback-time">
                    {fb.timestamp?.toDate().toLocaleString()}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}





{/******************************************************************************************************************************/}



  {activeTab === 'addLoyaltyCustomer' && (
  <div className="tab-content active">
    <h3>Add Loyalty Customer</h3>
    <div className="loyalty-form-container">

      {success && (
        <div className="success-message">
          Thank you! Your loyalty information has been saved and emailed successfully.
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {/* Full Name */}
        <div className="form-group">
          <label htmlFor="name">Full Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        {/* Loyalty Number */}
        <div className="form-group">
          <label htmlFor="loyaltyNumber">Loyalty Number</label>
          <input
            type="text"
            id="loyaltyNumber"
            name="loyaltyNumber"
            value={formData.loyaltyNumber}
            onChange={handleChange}
            required
          />
        </div>

        {/* Address */}
        <div className="form-group">
          <label htmlFor="address">Address</label>
          <textarea
            id="address"
            name="address"
            rows="3"
            value={formData.address}
            onChange={handleChange}
            required
          />
        </div>

        {/* Phone */}
        <div className="form-group">
          <label htmlFor="phone">Phone Number</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        {/* Email */}
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

       

        <button 
          type="submit" 
          className="submit-btn"
          disabled={submitting}
        >
          {submitting ? 'Saving...' : 'Add Customer'}
        </button>
      </form>
    </div>
  </div>
)}



{/******************************************************************************************************************************/}


    <div className="loyalty-view-container">
      {activeTab === 'viewAllLoyaltyBase' && (
        <>
          <div className="loyalty-header">
            <h2>Loyalty Customers</h2>
            
            <div className="controls">
              <div className="search-filter-container">
                <div className="search-box">
                  <FontAwesomeIcon icon={faSearch} className="search-icon" />
                  <input
                    type="text"
                    placeholder="Search by name, phone, or loyalty number..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="search-input"
                  />
                </div>
                
                <div className="filter-dropdown">
                  <FontAwesomeIcon icon={faFilter} className="filter-icon" />
                  <select
                    value={yearFilter}
                    onChange={(e) => setYearFilter(e.target.value)}
                    className="year-filter"
                  >
                    <option value="">All Years</option>
                    {getYearOptions().map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          
          {loading ? (
            <div className="loading-spinner">Loading customers...</div>
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : filteredCustomers.length === 0 ? (
            <p className="no-results">No loyalty customers found{searchTerm ? ` matching "${searchTerm}"` : ''}.</p>
          ) : (
            <div className="table-responsive">
              <table className="loyalty-table">
                <thead>
                  <tr>
                    <th>Loyalty #</th>
                    <th>Name</th>
                    <th>Joined Date</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCustomers.map((customer) => (
                    <tr key={customer.id}>
                      <td className="loyalty-number">
                        {customer.loyaltyNumber.padStart(3, '0')}
                      </td>
                      <td>
                        {editingId === customer.id ? (
                          <input
                            type="text"
                            value={editForm.name}
                            onChange={(e) => setEditForm({...editForm, name: e.target.value})}
                            className="edit-input"
                          />
                        ) : (
                          customer.name
                        )}
                      </td>
                      <td>{formatDate(customer.joinedDate)}</td>
                      <td>
                        {editingId === customer.id ? (
                          <input
                            type="email"
                            value={editForm.email}
                            onChange={(e) => setEditForm({...editForm, email: e.target.value})}
                            className="edit-input"
                          />
                        ) : (
                          customer.email
                        )}
                      </td>
                      <td>
                        {editingId === customer.id ? (
                          <input
                            type="tel"
                            value={editForm.phone}
                            onChange={(e) => setEditForm({...editForm, phone: e.target.value})}
                            className="edit-input"
                          />
                        ) : (
                          customer.phone
                        )}
                      </td>
                      <td className="address-cell">
                        {editingId === customer.id ? (
                          <input
                            type="text"
                            value={editForm.address}
                            onChange={(e) => setEditForm({...editForm, address: e.target.value})}
                            className="edit-input"
                          />
                        ) : (
                          customer.address
                        )}
                      </td>
                      <td className="actions">
                        {editingId === customer.id ? (
                          <>
                            <button 
                              onClick={handleSaveEdit}
                              className="action-btn save-btn"
                              title="Save"
                            >
                              <FontAwesomeIcon icon={faSave} />
                            </button>
                            <button
                              onClick={handleCancelEdit}
                              className="action-btn cancel-btn"
                              title="Cancel"
                            >
                              <FontAwesomeIcon icon={faTimes} />
                            </button>
                          </>
                        ) : (
                          <>
                            <button 
                              onClick={() => handleEdit(customer)}
                              className="action-btn edit-btn"
                              title="Edit"
                            >
                              <FontAwesomeIcon icon={faEdit} />
                            </button>
                            <button
                              onClick={() => handleDelete(customer.id)}
                              className="action-btn delete-btn"
                              title="Delete"
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      <style jsx>{`
        .loyalty-view-container {
          width: 100%;
          padding: 20px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        }
        
        .loyalty-header {
          display: flex;
          flex-direction: column;
          gap: 20px;
          margin-bottom: 20px;
        }
        
        .controls {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .search-filter-container {
          display: flex;
          gap: 15px;
          align-items: center;
        }
        
        .search-box {
          position: relative;
          display: flex;
          align-items: center;
        }
        
  .search-input {
    text-indent: 40px; /* 25px for icon + 15px for placeholder */
    padding: 8px 15px; /* Standard padding on right and top/bottom */
    /* other styles remain the same */
  }
  
  .search-input::placeholder {
    text-indent: 0; /* Reset for placeholder */
    padding-left: 25px; /* Move placeholder right */
  }
        
        .search-icon, .filter-icon {
          position: absolute;
          left: 10px;
          color: #777;
        }
        
        .filter-dropdown {
          position: relative;
          display: flex;
          align-items: center;
        }
        
        .year-filter {
          padding: 8px 15px 8px 35px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
          appearance: none;
          background-color: white;
          cursor: pointer;
        }
        
        .table-responsive {
          width: 100%;
          overflow-x: auto;
        }
        
        .loyalty-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 14px;
        }
        
        .loyalty-table th {
          background-color: #f8f9fa;
          padding: 12px 15px;
          text-align: left;
          font-weight: 600;
          color: #495057;
          border-bottom: 2px solid #e9ecef;
        }
        
        .loyalty-table td {
          padding: 12px 15px;
          border-bottom: 1px solid #e9ecef;
          vertical-align: top;
        }
        
        .loyalty-table tr:hover td {
          background-color: #f8f9fa;
        }
        
        .loyalty-number {
          font-family: monospace;
          font-weight: bold;
          color: #2c3e50;
        }
        
        .address-cell {
          max-width: 200px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        
        .edit-input {
          padding: 6px 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          width: 100%;
          font-size: 14px;
        }
        
        .actions {
          display: flex;
          gap: 8px;
          justify-content: center;
        }
        
        .action-btn {
          width: 32px;
          height: 32px;
          border: none;
          border-radius: 4px;
          background: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
        }
        
        .edit-btn {
          color: #3498db;
        }
        
        .edit-btn:hover {
          background-color: #e3f2fd;
        }
        
        .delete-btn {
          color: #e74c3c;
        }
        
        .delete-btn:hover {
          background-color: #fde8e6;
        }
        
        .save-btn {
          color: #fff;
          background-color: #2ecc71;
        }
        
        .save-btn:hover {
          background-color: #27ae60;
        }
        
        .cancel-btn {
          color: #fff;
          background-color: #95a5a6;
        }
        
        .cancel-btn:hover {
          background-color: #7f8c8d;
        }
        
        .loading-spinner {
          padding: 20px;
          text-align: center;
          color: #7f8c8d;
        }
        
        .error-message {
          padding: 20px;
          text-align: center;
          color: #e74c3c;
        }
        
        .no-results {
          padding: 20px;
          text-align: center;
          color: #7f8c8d;
        }
      `}</style>
    </div>








{/******************************************************************************************************************************/}

        {/* {activeTab === 'manageUsers' && (
          <div className="tab-content active">
            <h3>Manage Members</h3>
            <table className="users-table">
              <thead>
                <tr>
                <th>Name</th>
                  <th>Email</th>
                  <th>Contact No</th>
                  <th>Role</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.contactNo}</td>
                    <td>{user.role}</td>
                    <td>
                      <button className="remove-btn" onClick={() => handleRemoveUser(user.id)}>
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )} */}

{/******************************************************************************************************************************/}


        {activeTab === "contactMessage" && (
    <div className="contact-messages-container">
      <h2>Contact Messages</h2>
      
      {loading ? (
        <div className="loading-spinner">Loading messages...</div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : messages.length === 0 ? (
        <p>No messages found.</p>
      ) : (
        <div className="messages-table-container">
          <table className="users-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Message</th>
        
              </tr>
            </thead>
            <tbody>
              {messages.map((msg) => (
                <tr key={msg.id} className={`message-row ${msg.status}`}>
                  <td>{msg.formattedDate}</td>
                  <td>{msg.name}</td>
                  <td>{msg.email}</td>
                  <td>{msg.phone}</td>
                  <td className="message-content">{msg.message}</td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
        )}

{/******************************************************************************************************************************/}


      </div>
    </div>
  );
}

export default AdminPanel;
